
import { combineReducers } from 'redux'
import appReducer from './appReducer'
import transcriptViewerReducer from '../../pages/transcript-viewer/transcriptViewerReducer'
import loginReducer from '../../pages/login/loginReducer'

export const initialStates = {
  app: appReducer(undefined, {}),
  transcriptViewer: transcriptViewerReducer(undefined, {}),
  login: loginReducer(undefined, {}),
}

export const rootReducer = combineReducers({
  app: appReducer,
  transcriptViewer: transcriptViewerReducer,
  login: loginReducer,
})
